// Attributs partagés par les composants de « Nouvelle demande ».
/** Repère de focus : le panneau retrouve ses champs par cet attribut (le même texte sert aux champs de période et aux boutons). */
export const FOCUS_ATTR = 'data-fid';
/** Pastilles de séance : `c:<cle>` dans le calendrier, `p:<cle>` dans le panneau. Jamais `data-cle` (le retour de focus du calendrier « Mes demandes » s'en sert). */
export const PASTILLE_ATTR = 'data-pastille';
export const pastilleId = (ou: 'c' | 'p', cle: string): string => `${ou}:${cle}`;
